import { ApiClient } from '../../ApiClient';
import {
  CollectionDTO,
  CreateCollectionDTO,
  UpdateCollectionDTO,
  AddProductsToCollectionDTO,
  RemoveProductsFromCollectionDTO,
} from '../dto/CollectionDTO';

export class CollectionDataSource {
  constructor(private api: ApiClient) {}

  async getCollections(): Promise<CollectionDTO[]> {
    const response = await this.api.get<CollectionDTO[]>('/products/collections');
    return response.data;
  }

  async getCollection(collectionId: string): Promise<CollectionDTO> {
    const response = await this.api.get<CollectionDTO>(`/products/collections/${collectionId}`);
    return response.data;
  }

  async createCollection(data: CreateCollectionDTO): Promise<CollectionDTO> {
    const response = await this.api.post<CollectionDTO>('/products/collections', data);
    return response.data;
  }

  async updateCollection(
    collectionId: string,
    data: UpdateCollectionDTO
  ): Promise<CollectionDTO> {
    const response = await this.api.put<CollectionDTO>(
      `/collections/${collectionId}`,
      data
    );
    return response.data;
  }

  async deleteCollection(collectionId: string): Promise<void> {
    await this.api.delete(`/products/collections/${collectionId}`);
  }

  async addProductsToCollection(
    collectionId: string,
    body: AddProductsToCollectionDTO
  ): Promise<CollectionDTO> {
    const response = await this.api.post<CollectionDTO>(
      `/products/collections/${collectionId}/products`,
      body
    );
    return response.data;
  }

  async removeProductsFromCollection(
    collectionId: string,
    body: RemoveProductsFromCollectionDTO
  ): Promise<void> {
    await this.api.delete(`/products/collections/${collectionId}/products`, {
      data: body,
    });
  }
}
